import type { RollSource } from '../../actions/roll-source.js';
import { type Row, itemField, scalar, upper } from '../context.js';

export const REDUCE_DAMAGE_ROLL = '28B4E29C-5D8D-57CC-7634-761CEBD01190';
export interface DamageReduction { dice: number; die: number; mod: number; label: string }

/** calc_total's active reduce status: numeric hydrated mod, fresh dice each hit, no consumption. */
export function damageReductionPlan(definition: Row, value: (row: Row, key: string) => unknown): DamageReduction | null | 'invalid' {
  if (upper(scalar(value(definition, 'roll_type'))) !== REDUCE_DAMAGE_ROLL) return null;
  const dice = Math.trunc(Number(scalar(value(definition, 'dice')) ?? 0));
  const die = Math.trunc(Number(scalar(value(definition, 'die')) ?? 0));
  if (dice <= 0 || die <= 0) return null;
  if (!Number.isSafeInteger(dice) || !Number.isSafeInteger(die) || dice > 100 || die > 1000) return 'invalid';
  const rawMod = scalar(value(definition, 'mod'));
  const mod = typeof rawMod === 'number' || (typeof rawMod === 'string' && rawMod.trim() !== '' && Number.isFinite(Number(rawMod)))
    ? Math.trunc(Number(rawMod)) : 0;
  return { dice, die, mod, label: String(itemField(definition, 'item_name') ?? 'Reduce Damage') };
}

export function rollDamageReductions(total: number, reductions: readonly DamageReduction[], roll: RollSource): {
  total: number; adjustments: Array<{ face: string; label: string }>;
} {
  const adjustments: Array<{ face: string; label: string }> = [];
  for (const reduction of reductions) {
    let amount = reduction.mod;
    for (let i = 0; i < reduction.dice; i++) amount += roll.d(reduction.die);
    if (amount <= 0) continue;
    total = Math.max(0, total - amount);
    adjustments.push({ face: '-' + amount, label: reduction.label });
  }
  return { total, adjustments };
}
